import { Loader2 } from 'lucide-react';

type LoadingStateProps = {
    label?: string;
    size?: 'sm' | 'md' | 'lg';
    mode?: 'inline' | 'block' | 'overlay' | 'page';
    className?: string;
};

const SIZE_MAP = {
    sm: {
        spinner: 'h-4 w-4',
        text: 'text-xs',
        gap: 'gap-2',
    },
    md: {
        spinner: 'h-6 w-6',
        text: 'text-sm',
        gap: 'gap-3',
    },
    lg: {
        spinner: 'h-8 w-8',
        text: 'text-sm',
        gap: 'gap-3',
    },
} as const;

const MODE_MAP = {
    inline: 'inline-flex items-center justify-center',
    block: 'flex min-h-[160px] w-full items-center justify-center rounded-2xl border border-stone-200 bg-white/85',
    overlay: 'absolute inset-0 z-10 flex items-center justify-center rounded-[inherit] bg-white/72 backdrop-blur-[1px]',
    page: 'flex min-h-[40vh] w-full items-center justify-center',
} as const;

export const LoadingState = ({
    label = 'Loading...',
    size = 'md',
    mode = 'block',
    className = '',
}: LoadingStateProps) => {
    const selectedSize = SIZE_MAP[size];
    const selectedMode = MODE_MAP[mode];

    return (
        <div className={`${selectedMode} ${className}`.trim()}>
            <div className={`flex flex-col items-center justify-center ${selectedSize.gap}`}>
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-stone-100/90 ring-1 ring-stone-200/80">
                    <Loader2 className={`${selectedSize.spinner} animate-spin text-green-700`} strokeWidth={2.25} />
                </div>
                {label ? (
                    <p className={`${selectedSize.text} font-medium text-stone-500`}>{label}</p>
                ) : null}
            </div>
        </div>
    );
};

export const InlineSpinner = ({ className = '' }: { className?: string }) => (
    <Loader2 className={`h-4 w-4 animate-spin text-green-700 ${className}`.trim()} strokeWidth={2.25} />
);
